module.exports = __webpack_public_path__ + "static/media/Quadricycle.8c1ea6f0.svg";